export default "__VITE_ASSET__4XqgjiPY__"